import axios from 'axios';
import { PAGE_SIZE_250, FIRST_PAGE } from '../../services/pagination-service';

const shipmentsAdvancedSearchEndpoint = '/shippinggrid/simple';
export const getAdvancedSearchShipments = (
  filters,
  pageNumber = FIRST_PAGE,
  pageSize = PAGE_SIZE_250,
  orderBy = 'orderNumber',
  orderByDirection = 'descending',
) => {
  const getShipments = axios
    .post(shipmentsAdvancedSearchEndpoint, {
      filter: {
        ...filters,
      },
      page: {
        pageNumber,
        pageSize,
      },
      orderBy,
      orderByDirection,
    })
    .then((response) => {
      const { data = {} } = response;
      return data;
    });

  return getShipments;
};

// fulfillments done by its grid in container

const batchesAdvancedSearchEndpoint = '/fulfillmentPlanSetGrid/advancedsearch';
export const getAdvancedSearchBatches = (filters, pageNumber = FIRST_PAGE, pageSize = PAGE_SIZE_250, orderBy = 'orderNumberDesc') => {
  const getOrders = axios
    .post(batchesAdvancedSearchEndpoint, {
      ...filters,
      page: pageNumber,
      pageSize,
      fulfillmentPlanSetGridOrderBy: orderBy,
    })
    .then((response) => {
      const { data = { orders: [] } } = response;
      return data;
    });

  return getOrders;
};

const returnsAdvancedSearchEndpoint = '/returnGrid/advancedsearch';
export const getAdvancedSearchReturns = (
  filters,
  pageNumber = FIRST_PAGE,
  pageSize = PAGE_SIZE_250,
  orderBy = 'orderNumber',
  orderByDirection = 'descending',
) => {
  const getOrders = axios
    .post(returnsAdvancedSearchEndpoint, {
      ...filters,
      page: pageNumber,
      pageSize,
      orderBy,
      orderByDirection,
    })
    .then((response) => {
      const { data = { orders: [] } } = response;
      return data;
    });

  return getOrders;
};
